import type {
  BadgeUdsCustomVariants,
  BadgeUdsFlatData,
  BadgeUdsVariants,
} from "@gatsby-plugin-generic-page/fragments/badgeUds"
import isEmpty from "~/lib/isEmpty"

// TODO [ONESTORE-409]: remove when ai and blue variants will be implemented in UDS badge
const getFormattedLabel = (
  label: string,
  variant: BadgeUdsVariants | BadgeUdsCustomVariants
): string => {
  if (variant === "ai") return `**${label}**`

  if (variant === "blue") return `*${label}*`

  return label
}

export const getMarkdownUdsBadge = ({
  text,
  variant,
  icon,
}: BadgeUdsFlatData): string => {
  const baseLabel = !isEmpty(icon) ? `[icon:${icon.iconId}] ${text}` : text

  const label = getFormattedLabel(baseLabel, variant)

  const resolvedVariant = (
    variant === "ai" || variant === "blue" ? "promo" : variant
  ) as BadgeUdsVariants

  return `[${label}](badge-${resolvedVariant})`
}
